import type { TopGamesGame } from '../../../types/api/api.types';
import { useAppStore } from '../../../store/app/appStore';

export const fetchTopGames = async (): Promise<TopGamesGame[]> => {
  const apiHost = useAppStore.getState().settings.apiHost;
  const endpointPath = '/api/history/statistics/top-games';
  const url = `${apiHost}${endpointPath}`;
  const response = await fetch(url);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ message: 'Network response was not ok and error response is not valid JSON' }));
    throw new Error(errorData.message || `Failed to fetch top games: ${response.statusText} (URL: ${url})`);
  }
  return response.json() as Promise<TopGamesGame[]>;
};
